import styled from 'styled-components'
import { BREAKPOINT_SM } from '../../theme/ota'

interface ButtonProps {
  corner?: boolean
}

export const ThumbContainer = styled.div`
  height: 100%;
  width: 100%;
  position: relative;
`

export const Thumbnail = styled.div<{ src: string; roundImg: string }>`
  background-color: ${({ theme }) => theme.colors?.gray3};
  background-image: url(${({ src }) => src});
  background-position: 50%;
  background-size: cover;
  background-repeat: no-repeat;
  border-radius: 4px;
  height: 100%;
  width: 100%;
`

export const ButtonGallery = styled.div<ButtonProps>`
  align-items: center;
  background-color: ${({ theme }) => theme.colors?.textColor};
  border-radius: 2px;
  bottom: ${({ corner }) => (corner ? 4 : 10)}px;
  display: flex;
  gap: 6px;
  height: 25px;
  opacity: 0.75;
  padding: 5px;
  position: absolute;
  right: ${({ corner }) => (corner ? 4 : 10)}px;
  min-width: ${({ corner }) => (corner ? 47 : 0)}px;
  z-index: 5;
  cursor: pointer;

  img {
    opacity: 0.6;
  }

  p {
    color: ${({ theme }) => theme.colors?.white};
    font-size: 11px;
    line-height: 19.2px;
    margin: 0;

    @media (max-width: calc(${BREAKPOINT_SM})) {
      font-size: 13px;
    }
  }
`

export const MobileModalContents = styled.div`
  min-height: calc(100vh - 82px);
`
